import * as React from 'react';
import { useLocation } from 'react-router';

const useRouteChange = (): void => {
  const location = useLocation();
  React.useEffect(() => {
    if (!window.analytics) return;

    window.analytics.page();
  }, [location]);
};

export default useRouteChange;
